import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from '@mui/material/styles';
import 'sanitize.css/sanitize.css';
import './index.css';
import App from './web/App';
import configureStore from './store/configureStore.web';
import LanguageProvider from './web/hoc/languageProvider';
import translationMessages from './web/i18n';
import theme from './web/muiTheme';
import history from './web/history';
import RTLHandler from './web/hoc/RTLHandler';

const { store, persistor } = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <LanguageProvider messages={translationMessages}>
        <Router history={history}>
          <ThemeProvider theme={theme}>
            <RTLHandler>
              <App />
            </RTLHandler>
          </ThemeProvider>
        </Router>
      </LanguageProvider>
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);
